import { render, staticRenderFns } from "./DuplicateMediaCallFromProjectBtn.vue?vue&type=template&id=403d4cfa&"
import script from "./DuplicateMediaCallFromProjectBtn.vue?vue&type=script&lang=js&"
export * from "./DuplicateMediaCallFromProjectBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports